import * as React from "react";
import { JSX } from "react/jsx-runtime";

const SVGComponent = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    width={21}
    height={18}
    viewBox="0 0 21 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.6612 12.8664C19.6612 14.9105 18.1038 16.5706 16.1916 16.5706H4.80841C2.89623 16.5706 1.33876 14.9104 1.33876 12.8664V5.13354C1.33876 4.45133 1.51372 3.81057 1.81741 3.26064L7.37173 9.19058C8.20269 10.0803 9.31548 10.5706 10.5012 10.5706C11.6845 10.5706 12.7973 10.0803 13.6282 9.19058L19.1825 3.26064C19.4863 3.81057 19.6612 4.45128 19.6612 5.13354V12.8664H19.6612ZM16.1916 1.4293H4.80841C4.01876 1.4293 3.28982 1.71462 2.7067 2.18933L8.3169 8.18153C8.89762 8.79888 9.67266 9.14131 10.5012 9.14131C11.3273 9.14131 12.1024 8.79888 12.6831 8.18153L18.2933 2.18933C17.7102 1.71462 16.9813 1.4293 16.1916 1.4293ZM16.1916 0H4.80841C2.15759 0 0 2.30351 0 5.13359V12.8664C0 15.6991 2.15759 18 4.80841 18H16.1916C18.8424 18 21 15.6991 21 12.8664V5.13354C21 2.30346 18.8424 0 16.1916 0Z"
      fill="#1F2A37"
    />
  </svg>
);

export default SVGComponent;
